module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-productos/catalogo-productos.component.scss
// module id = ./src/app/components/catalogo-productos/catalogo-productos.component.scss
// module chunks = main